import { render, staticRenderFns } from "./api-keys-listing.vue?vue&type=template&id=47b96b1d&scoped=true&"
import script from "./api-keys-listing.vue?vue&type=script&lang=js&"
export * from "./api-keys-listing.vue?vue&type=script&lang=js&"
import style0 from "./api-keys-listing.vue?vue&type=style&index=0&id=47b96b1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b96b1d",
  null
  
)

export default component.exports